module.exports = "//static.hsappstatic.net/ContentComponents/static-2.71836/img/payment_methods.png"